import React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";

export default function Label({ children, color = undefined }) {
  const theme = useTheme();

  return (
    <Typography
      sx={{
        fontSize: "18px",
        fontWeight: "bold",
        color: color || theme.palette.accent?.dark || "black", // Fallback color if accent.dark is not defined
      }}
    >
      {children}
    </Typography>
  );
}

Label.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
};
